import { ActionTypes } from 'modules/experiments/takeover/ducks/actionTypes';
import {
  ExperimentTakeoverAction,
  ExperimentTakeoverState,
} from 'modules/experiments/takeover/types';

export const initialExperimentTakeoverState: ExperimentTakeoverState = {
  isModalOpen: false,
  isDrawerOpen: false,
  source: null,
};

export const experimentTakeoverReducer = (
  state = initialExperimentTakeoverState,
  action?: ExperimentTakeoverAction,
) => {
  switch (action?.type) {
    case ActionTypes.MODAL_OPEN:
      return {
        ...state,
        isModalOpen: true,
        isDrawerOpen: false,
      };

    case ActionTypes.DRAWER_OPEN:
    case ActionTypes.DRAWER_OPEN_WITH_DATA:
      return {
        ...state,
        isModalOpen: false,
        isDrawerOpen: true,
      };

    case ActionTypes.SET_SOURCE: {
      const source = action?.payload || state.source;
      return {
        ...state,
        source,
      };
    }

    case ActionTypes.MODAL_CLOSE:
    case ActionTypes.DRAWER_CLOSE:
      return {
        ...state,
        isModalOpen: false,
        isDrawerOpen: false,
      };

    default:
      return state;
  }
};
